import * as Scrivito from "scrivito"
import { ScrivitoLink } from "scrivito/scrivito-link/ScrivitoLink"
import { LinkList, LinkListVariant } from "shared/ui/link-list/LinkList"

import { LinkListWidget } from "./LinkListWidgetClass"

Scrivito.provideComponent(LinkListWidget, ({ widget }) => {
  const hasIcons = widget.get("hasIcons")

  if (!hasIcons) {
    return (
      <LinkList
        label={<Scrivito.ContentTag content={widget} attribute="title" />}
        variant={widget.get("variant") as LinkListVariant}
        aria-label={widget.get("title")}
      >
        {widget.get("links").map((link: Scrivito.Link) => {
          const linkTitle = link.title() || link.url()
          return (
            <LinkList.LinkWrapper key={linkTitle}>
              <ScrivitoLink
                className="link"
                to={link}
                label={linkTitle}
                title={linkTitle}
              >
                {linkTitle}
              </ScrivitoLink>
            </LinkList.LinkWrapper>
          )
        })}
      </LinkList>
    )
  }

  return (
    <div className="link-list">
      <Scrivito.ContentTag
        tag="h2"
        className="link-list__label h6"
        content={widget}
        attribute="title"
      />

      <Scrivito.ContentTag
        className="link-list__list"
        content={widget}
        attribute="iconLinks"
      />
    </div>
  )
})
